"use client"
import React from "react";
import {Box, Typography} from "@mui/material";
import FaIcon from "@/components/utilities/fa-icon";
import Container from "@mui/material/Container";
import {useTheme} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Rules from "@/components/common/rules";


export default function TermsOfSaleView() {
    const theme = useTheme()


    return (
        <Box minHeight = "100vh" className = "cog-background" >
            <Container
                maxWidth = 'lg'
                sx = {{
                    py: 6,
                }}
            >
                <Box
                    display = 'flex'
                    alignItems = 'center'
                    flexDirection = 'column'
                    mb = {3}
                >
                    <Typography fontSize = {20} mb = {2} textAlign = "left" fontWeight = {400} >
                        قوانین و شرایط خرید
                    </Typography >
                    <FaIcon fontSize = {24} color = {theme.palette.primary.main} faIcon = 'fa-arrow-down' />

                </Box >

                <Paper sx = {{p: 3}} >
                    <Rules />
                </Paper >

            </Container >

        </Box >
    )
}
